module.exports = __webpack_public_path__ + "static/img/14003015.5873e741.png";